import React, { useEffect } from "react";
import "../modal/Modal.css";
import close from "../../../img/close.svg";

export default function Modal({ open, children, footer, onClose }) {

  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  if (!open) return null;

  return (
    <div className="background-style" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        
        <div className="close-container">
          <img
            src={close}
            className="close-btn"
            onClick={onClose}
            alt="close"
          />
        </div>

        <div className="modal-body">
          {children}
        </div>

        {footer && (
          <div className="modal-footer">
            {footer}
          </div>
        )}

      </div>
    </div>
  );
}